import { S as STATUS, d as IMA_AD_TYPE } from './index-fd930a73.js';
const isClientSideAdvertising = status => {
  var _a;
  if (!(status.to === STATUS.ADVERTISING || status.to === STATUS.ADVERTISING_PAUSED)) return false;
  if (((_a = status.data) === null || _a === void 0 ? void 0 : _a.adType) === IMA_AD_TYPE.CLIENTSIDE) return true;
  return false;
};
export { isClientSideAdvertising as i };